module.exports = __webpack_public_path__ + "img/arrow-right-long.503483bf.svg";